<!-- 评价 -->
<template>
    <div class="imRate-wrapper">
        <div v-show="!resultVisible" class="main">
            <p class="title">
                {{ $t('imClient.rate.title') }}
            </p>
            <el-row>
                <!-- <el-rate v-model="dataForm.score" show-text :texts="['非常不满意', '不满意', '一般', '满意', '非常满意']">
                </el-rate> -->
                <span class="imRate-choose">
                    <!-- <div><img src="@/assets/satisfied.png">满意</div>
                    <div><img src="@/assets/dissatisfied.png">不满意</div> -->
                    <div
                        :class="{'selected': selected === 'satisfied'}"
                        @click="selectOption('satisfied')"
                    >
                        <img :src="selected === 'satisfied' ? satisfiedSelectedImg : satisfiedImg">
                        <span style="position: relative;bottom: 1px;">{{ $t('imClient.rate.satisfied') }}</span>
                    </div>

                    <!-- 不满意 -->
                    <div
                        :class="{'selected': selected === 'dissatisfied'}"
                        @click="selectOption('dissatisfied')"
                    >
                        <img :src="selected === 'dissatisfied' ? dissatisfiedSelectedImg : dissatisfiedImg">
                        <span style="position: relative;bottom: 1px;">{{ $t('imClient.rate.dissatisfied') }}</span>
                    </div>
                </span>
            </el-row>
            <el-row>
                <el-input type="textarea" :maxlength="50" :rows="4" resize="none" :placeholder="$t('imClient.rate.suggestionPlaceholder')" v-model="dataForm.remark"></el-input>
            </el-row>
            <el-row style="display: flex;justify-content: space-between;">
                <el-button type="primary" class="submit-btn " size="mini" @click="submit" >{{ $t('imClient.rate.submit') }}</el-button>
                <el-button type="text" class="submit-btn " size="mini"  @click="submitEnd" >{{ $t('imClient.rate.endNow') }}</el-button>
                <el-button type="text" class="submit-btn " size="mini" @click="submitCancel" >{{ $t('imClient.rate.backToChat') }}</el-button>
            </el-row>


            <!-- <el-button type="primary" class="submit-btn position-h-mid" @click="submit" :disabled="dataForm.score==null">确定</el-button> -->
        </div>
        <!-- 评价后的界面 -->
        <div v-show="resultVisible" class="submit-main">
            <i class="fa fa-check-circle-o"></i>
            <p class="title">{{ $t('imClient.rate.success') }}</p>
        </div>
    </div>
</template>

<script>
import {evaluation} from '@/common/imCilent.js'
export default {
    props:{
            groupId:{
                type: String,
                default: ''
            },
            sendRateTwo:{
                type: Number,
                default: null
            },
            dataItem:{
                type: Object,
                default: null
            }
    },
    data() {
        return {
            resultVisible: false, // 满意度已提交
            dataForm: {
                rate:null,
                remark: ''
            },
            selected: 'satisfied', // 当前选中的选项
            satisfiedImg: require('@/assets/satisfied.png'), // 默认满意图片
            satisfiedSelectedImg: require('@/assets/satisfied_active.png'), // 选中满意图片
            dissatisfiedImg: require('@/assets/dissatisfied.png'), // 默认不满意图片
            dissatisfiedSelectedImg: require('@/assets/dissatisfied_active.png') // 选中不满意图片
                };
    },
    computed: {},
    watch: {},
    methods: {
        /**
         * init
         */
        init: function() {
            this.$data.resultVisible = false;
            this.$data.dataForm.rate = null;
            this.$data.dataForm.remark = '';
        },

        /**
         * 提交
         */
        submit: function() {
            // this.$data.resultVisible = true;
            this.dataForm.groupUniqueId = this.groupId;
            // TODO 提交
            if(this.selected == 'satisfied' ){
                this.dataForm.rate = 1;
            }else{
                this.dataForm.rate = 0;
            }
            this.dataForm.reply = this.sendRateTwo==null?1:this.sendRateTwo;
            if(this.sendRateTwo==0){
                this.dataForm.imMessageSessionId= this.dataItem.messageExpand.imMessageSessionId
            }else if(this.sendRateTwo==1){
                this.dataForm.imMessageSessionId= this.dataItem.contentExpand.imMessageSessionId
            }
            evaluation(this.dataForm).then(res=>{
                if(res.code == 200){
                      let data={
                        item:this.dataItem,
                        num:1
                      }
                      this.$emit('custom-event',data)
                      this.init();
                }
            })

        },
        // 立即结束
        submitEnd(){
            let data={

                 num:2
                      }
            this.$emit('custom-event',data)
            this.init();
        },
        // 回到会话
        submitCancel(){
            let data={

                      num:3
                    }
            this.$emit('custom-event',data)
            this.init();
        },
        selectOption(option) {
         this.selected = option;
    }
    },
};
</script>

<style lang="less">
.imRate-wrapper {
    height: 300px;
    & > .main {
        overflow: hidden;
        .title {
            text-align: left;
            font-size: 14px;
            color: #000000;
            margin-top: 15px;
            line-height: 1.2;
        }
        .el-rate {
            margin-top: 20px;
            text-align: center;
            margin-bottom: 36px;
            .el-rate__item {
                width: 18%;
                .el-rate__icon {
                    font-size: 20px;
                }
            }
            .el-rate__text {
                display: block;
                margin-top: 16px;
            }
        }
        textarea {
            width: 95%;
            margin: 10px auto 0px;
        }
        .submit-btn {
            // width: 100px;
            margin: 18px 0;
            padding: 8px 12px;
        }
    }
    & > .submit-main {
        .fa {
            display: table;
            margin: 85px auto 0px;
            color: #6bcc00;
            font-size: 50px;
        }
        .title {
            margin-top: 30px;
            font-size: 20px;
            text-align: center;
            color: #000000;
        }
    }
}
.imRate-choose {
    margin: 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    div{
        padding: 8px 16px;
        border-radius: 20px;
        text-align: center;
        color: #999;
        background: #f8f8f8;
        cursor: pointer;
        img {
            position: relative;
            top: 2px;
            right: 2px;
        }
    }
}
.imRate-choose div.selected {
  background-color: #2295FF;
  color: white;
}
.el-button--text {
    color: #333;
    border: 1px solid #999;
    border-radius: 20px;
}
.el-button--text:focus, .el-button--text:hover {
    color: #333;
    border: 1px solid #999;
    border-radius: 20px;
}
.el-button--primary {
    border-radius: 20px;
}
</style>
